import { FC, useMemo } from "react";
import Icon from "../Icon";
import Loading, { SpinnerSize } from "../Loading";
import Truncated from "../Truncated";
import { FileCardInternalProps } from "./types";
import { styles } from "./styles";

const DEFAULT_ERROR_MESSAGE = "Upload Failed.";

const FileCardInternal: FC<FileCardInternalProps> = ({
  fileName,
  loading,
  error
}) => {
  const errorMessage = useMemo(() => {
    if (loading) {
      return undefined;
    }
    if (error === true) {
      return DEFAULT_ERROR_MESSAGE;
    }
    if (typeof error === "string") {
      return error;
    }
    return undefined;
  }, [error, loading]);

  const offset = useMemo(() => {
    if (!fileName) {
      return undefined;
    }
    const extensionIndex = fileName.lastIndexOf(".");
    if (extensionIndex === -1) {
      return undefined;
    }
    return fileName.length - extensionIndex;
  }, [fileName]);

  return (
    <div css={styles.fileContent}>
      <div css={styles.iconContainer} aria-hidden="true">
        {loading && <Loading.Spinner size={SpinnerSize.SMALL} />}
        {!loading && errorMessage && (
          <Icon name="Warning" fill="var(--color-danger)" />
        )}
        {!loading && !errorMessage && (
          <Icon name="FileDocument" size="medium" />
        )}
      </div>
      <div css={styles.textContainer}>
        {!!errorMessage && (
          <span css={styles.errorText} role="alert">
            {errorMessage}
          </span>
        )}

        {!errorMessage && (
          <div css={styles.fileName}>
            <Truncated text={fileName} offset={offset} tooltip={true} />
          </div>
        )}
      </div>
    </div>
  );
};

export default FileCardInternal;
